import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select as MuiSelect, FormHelperText } from "@mui/material";

const AgentSelect = ({ name, rules, defaultValue, isFetching, agents, setSelectedAgentId }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => (
        <FormControl
          variant="outlined"
          fullWidth
          size="small"
          sx={{ minHeight: '48px' }}
          error={!!fieldState.error} // ✅ Highlight on error
        >
          <InputLabel>Select Staff</InputLabel>
          <MuiSelect
            {...field}
            label="Select Staff"
            disabled={isFetching}
            value={field.value ?? ""}
            onChange={(event) => {
              const selectedValue = event.target.value;
              field.onChange(selectedValue);
              setSelectedAgentId?.(selectedValue); // Update parent if provided
            }}
          >
            {agents?.map(agent => (
              <MenuItem key={agent.agentid} value={agent.agentid}>
                {agent.agentname}
              </MenuItem>
            ))}
          </MuiSelect>
          {fieldState.error && (
            <FormHelperText>{fieldState.error.message}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};

export default AgentSelect;
